module.exports = __webpack_public_path__ + "img/icon-social-juejin.b034525e.svg";